type LogoProps = {
  size?: number;
  className?: string;
  withWordmark?: boolean;
};

/** Product mark: the Afiatpour crystal with a MarketPulse leading-edge. */
export function Logo({ size = 32, className, withWordmark = false }: LogoProps) {
  return (
    <span className={`inline-flex items-center gap-3 ${className ?? ""}`}>
      <img
        src="/app-icon.png"
        width={size}
        height={size}
        alt="Afiat MarketPulse Pro"
        className="shrink-0"
        draggable={false}
      />
      {withWordmark && (
        <span className="flex flex-col leading-tight">
          <span className="text-sm font-semibold tracking-tight text-ink">
            Afiat MarketPulse Pro
          </span>
          <span className="text-2xs text-ink-faint">by Afiatpour LLC</span>
        </span>
      )}
    </span>
  );
}
